import React, {FC, useEffect, useState} from "react";
import {Animated} from "react-animated-css";
import {Link, useHistory} from "react-router-dom";
import {useAppVersions, useLastAppVersion, useThrottledLayoutEffect} from "../api/hooks";
import Footer from "../common/views/Footer";
import {AppVersion} from "../common/types/Types";
import {BYInput} from "../common/inputs/BYInput";
import {EntitySelect} from "../common/inputs/EntitySelect";
import {BYTable} from "../common/views/BYTable";
import {CommonHelper} from "../common/CommonHelper";

export const AppVersionList: FC = () => {
    const {data: appVersions = [], isLoading} = useAppVersions();

    const [filteredAppVersions, setFilteredAppVersions] = useState<AppVersion[]>(appVersions);
    const [searchText, setSearchText] = useState('');
    const [activeFilter, setActiveFilter] = useState(true);
    const history = useHistory();
    const {data: latestAppVersion} = useLastAppVersion();

    useEffect(() => {
        setFilteredAppVersions(appVersions);
    }, [appVersions])

    useThrottledLayoutEffect(() => {
        const filteredAppVersions = appVersions.filter((appVersion) => {
            const code = `${appVersion.id} ${appVersion.description} ${appVersion.disclaimer}`.toUpperCase();
            const searchTextUpperCased = searchText.toUpperCase();

            return code.includes(searchTextUpperCased) && appVersion.active === activeFilter;
        });

        setFilteredAppVersions(filteredAppVersions);
    }, 300, [searchText, appVersions, activeFilter]);

    return (
        <Animated animationIn="fadeIn" animationOut="fadeOut" isVisible={true}>
            <div className="container">
                <div className="row">
                    <div className="col">
                        <h3 className="my-4 color-green">Versions d'application <small
                            className="color-black">({appVersions.length})</small></h3>
                    </div>
                    <div className="col text-right tittle-buttons">
                        <Link type="submit"
                              className="btn btn-warning"
                              to={`${process.env.PUBLIC_URL}/app-version/new`}
                        >
                            Créer version <i className="fa fa-plus"></i>
                        </Link>
                    </div>
                </div>

                <div>
                    <div className="row mb-3">
                        <div className="col-9">
                            <BYInput type="text"
                                     title="Rechercher"
                                     placeholder="Description, message d'installation, id etc."
                                     className="form-control"
                                     value={searchText}
                                     onChange={(e) => setSearchText(e.target.value)}/>
                        </div>
                        <div className="col-3">
                            <EntitySelect
                                title={'Active'}
                                type="boolean"
                                onChange={(value) => setActiveFilter(value)}
                                value={activeFilter}
                            />
                        </div>
                    </div>

                    <BYTable
                        loading={isLoading}
                        data={filteredAppVersions}
                        columns={['id', 'description', 'disclaimer', 'mandatorySince', 'createdAt', 'downloadUrl', 'active']}
                        columnNames={['Identifiant', 'Description', "Message d'installation", 'Installer à partir du', 'Créé le', '', '']}
                        dataTransform={{
                            'mandatorySince': (appVersion) => CommonHelper.formatDate(appVersion.mandatorySince),
                            'createdAt': (appVersion) => CommonHelper.formatDate(appVersion.createdAt),
                            'downloadUrl': (appVersion) => <>
                                <a
                                    className="btn btn-sm btn-primary"
                                    href={appVersion.downloadUrl}
                                    target="_blank"
                                    rel="noreferrer"
                                ><i className="fa fa-file-download"></i></a>
                            </>,
                            'active': (appVersion) => appVersion.id === latestAppVersion?.id ? <span className="badge bg-success text-light">Active</span> : ''
                        }}
                        onClick={(user) => {
                            history.push(`/app-version/${user.id}`);
                        }}
                        keyExtractor={(user) => `app-version-list-${user.id}`}
                    />
                </div>

            </div>
            <Footer/>
        </Animated>
    );
};
